webpackJsonp([10],{

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(551)
  __webpack_require__(552)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(585),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-69d10534",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['licenseReportDetails'],
  data: function data() {
    return {
      err: '',
      licenseUsage: null,
      months: [{ value: '1', text: this.$lang.labels.january }, { value: '2', text: this.$lang.labels.february }, { value: '3', text: this.$lang.labels.march }, { value: '4', text: this.$lang.labels.april }, { value: '5', text: this.$lang.labels.may }, { value: '6', text: this.$lang.labels.june }, { value: '7', text: this.$lang.labels.july }, { value: '8', text: this.$lang.labels.august }, { value: '9', text: this.$lang.labels.september }, { value: '10', text: this.$lang.labels.october }, { value: '11', text: this.$lang.labels.november }, { value: '12', text: this.$lang.labels.december }],
      userCOuntPerLTHeaders: [{ text: '#', value: '', align: 'left', sortable: false }, { text: this.$lang.license.companyName, value: 'companyName', align: 'left', sortable: false }, { text: this.$lang.license.concUsers, value: 'noOfConcurrentUsers', align: 'center', sortable: false }],
      domainsPerWSHeaders: [{ text: '#', value: '', align: 'left', sortable: false }, { text: this.$lang.license.companyName, value: 'companyName', align: 'left', sortable: false }, { text: this.$lang.license.domainNames, value: 'domainNames', align: 'left', sortable: false }]
    };
  },

  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  computed: {
    webshopResPerSub: function webshopResPerSub() {
      var _this2 = this;

      var array = [];
      if (!this.licenseUsage || !this.licenseUsage.aggregatedWebShopResourcesPerSubscriptionModel) return array;
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.licenseUsage.aggregatedWebShopResourcesPerSubscriptionModel);
      if (keys.length === 0) return array;
      keys.sort(this.sortAlph());
      keys.forEach(function (key) {
        array.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
          type: key,
          companies: _this2.companyToArray(_this2.licenseUsage.aggregatedWebShopResourcesPerSubscriptionModel[key], 'webShopResources')
        }));
      });
      return array;
    },
    aggUserCountPerLicenseType: function aggUserCountPerLicenseType() {
      var _this3 = this;

      var array = [];
      if (!this.licenseUsage || !this.licenseUsage.aggregateUserCountsPerLicenseType) return array;
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.licenseUsage.aggregateUserCountsPerLicenseType);
      if (keys.length === 0) return array;
      keys.sort(this.sortAlph());
      keys.forEach(function (key) {
        array.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
          type: key,
          companies: _this3.objToArr(_this3.licenseUsage.aggregateUserCountsPerLicenseType[key])
        }));
      });
      return array;
    },
    userCountPerLicenseType: function userCountPerLicenseType() {
      var _this4 = this;

      var array = [];
      if (!this.licenseUsage || !this.licenseUsage.userCountsPerLicenseType) return array;
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.licenseUsage.userCountsPerLicenseType);
      if (keys.length === 0) return array;
      keys.sort(this.sortAlph());
      keys.forEach(function (key) {
        array.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
          type: key,
          companies: _this4.objToArr(_this4.licenseUsage.userCountsPerLicenseType[key])
        }));
      });
      return array;
    },
    aggDomainsPerWebSpace: function aggDomainsPerWebSpace() {
      var _this5 = this;

      var array = [];
      if (!this.licenseUsage || !this.licenseUsage.aggregateDomainNamesPerWebSpaceType) return array;
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.licenseUsage.aggregateDomainNamesPerWebSpaceType);
      if (keys.length === 0) return array;
      keys.sort(this.sortAlph());
      keys.forEach(function (key) {
        array.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
          type: key,
          companies: _this5.objToArr(_this5.licenseUsage.aggregateDomainNamesPerWebSpaceType[key])
        }));
      });
      return array;
    },
    counter: function counter() {
      var sum = 0;
      if (this.aggUserCountPerLicenseType) {
        this.aggUserCountPerLicenseType.forEach(function (entry) {
          if (entry.type === 'prod') {
            entry.companies.forEach(function (company) {
              sum += 1;
              if (company.noOfConcurrentUsers) {
                sum += company.noOfConcurrentUsers;
              }
              if (company.noOfConcurrentUsers > 0) {
                sum -= 1;
              }
            });
          }
        });
      }
      if (this.aggDomainsPerWebSpace) {
        this.aggDomainsPerWebSpace.forEach(function (type) {
          type.companies.forEach(function (company) {
            return sum += 0.5;
          });
        });
      }
      if (this.licenseUsage.webShopResourceDetails && this.licenseUsage.webShopResourceDetails.noOfActiveWebShopResources) {
        sum += this.licenseUsage.webShopResourceDetails.noOfActiveWebShopResources;
      }
      if (sum < 0) {
        sum = 0;
      }
      return sum;
    }
  },
  methods: {
    getOrderData: function getOrderData(parent, object, key) {
      return !parent || !parent[object] ? '-' : parent[object][key];
    },
    companyToArray: function companyToArray(type, param) {
      var _this6 = this;

      if (!type) return [];
      var array = [];
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(type);
      keys.sort(this.sortAlph());
      keys.forEach(function (key) {
        var company = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, param ? type[key][param] : type[key]);
        var companyKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(company);
        companyKeys.sort(_this6.sortAlph());
        companyKeys.forEach(function (companyKey) {
          return array.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, company[companyKey], { companyName: key }));
        });
      });
      return array;
    },
    objToArr: function objToArr(type) {
      if (!type) return [];
      var array = [];
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(type);
      keys.sort(this.sortAlph());
      keys.forEach(function (key) {
        return array.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, type[key], { companyName: key }));
      });
      return array;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm');
    },
    getSortedKeys: function getSortedKeys(obj) {
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj);
      keys.sort(this.sortAlph());
      return keys;
    },
    sortAlph: function sortAlph(prop) {
      return function (a, b) {
        var keya = prop ? a[prop].toUpperCase() : a.toUpperCase();
        var keyb = prop ? b[prop].toUpperCase() : b.toUpperCase();
        if (keya < keyb) return -1;
        return keya > keyb ? 1 : 0;
      };
    }
  },
  created: function created() {
    var _this7 = this;

    this.$http.get('licenseusage/' + this.licenseReportDetails.type + '/' + this.licenseReportDetails.id).then(function (res) {
      if (res.body.status === 'Success') {
        _this7.licenseUsage = res.body.licenseUsage;
        return;
      }
      _this7.err = res.body.statusText;
    }, function (err) {
      _this7.err = err.body.statusText || err.body.message;
    });
  }
});

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, ".my-table thead th{padding:0 12px!important;opacity:.75!important}.my-table thead .topHeader{position:absolute;top:8px;font-size:15px;right:-45%;width:100%;display:block}.my-table thead .bottomHeader{padding:18px 24px 0!important}.my-table thead th:first-of-type{width:20px!important}.my-table{border:1px solid rgba(0,0,0,.12)!important}.my-table .customHeader{position:relative;padding:0!important}.my-table .customHeader td.bottomHeader{padding:18px 24px 0!important;display:block}.my-table thead tr:first-of-type{height:60px!important}.index-w{width:20px!important}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/LicenseReportDetailsModal.vue"],"names":[],"mappings":"AACA,mBACE,yBAA2B,AAC3B,qBAAwB,CACzB,AACD,2BACE,kBAAmB,AACnB,QAAS,AACT,eAAgB,AAChB,WAAY,AACZ,WAAY,AACZ,aAAe,CAChB,AACD,8BACE,6BAAqC,CACtC,AACD,iCACE,oBAAuB,CACxB,AACD,UACE,0CAAiD,CAClD,AACD,wBACI,kBAAmB,AACnB,mBAAsB,CACzB,AACD,wCACM,8BAAqC,AACrC,aAAe,CACpB,AACD,iCACI,qBAAwB,CAC3B,AACD,SACE,oBAAuB,CACxB","file":"LicenseReportDetailsModal.vue","sourcesContent":["\n.my-table thead th {\n  padding: 0 12px !important;\n  opacity: .75 !important;\n}\n.my-table thead .topHeader {\n  position: absolute;\n  top: 8px;\n  font-size: 15px;\n  right: -45%;\n  width: 100%;\n  display: block;\n}\n.my-table thead .bottomHeader {\n  padding: 18px 24px 0 24px !important;\n}\n.my-table thead th:first-of-type {\n  width: 20px !important;\n}\n.my-table {\n  border: 1px solid rgba(0, 0, 0, 0.12) !important;\n}\n.my-table .customHeader {\n    position: relative;\n    padding: 0 !important;\n}\n.my-table .customHeader td.bottomHeader {\n      padding: 18px 24px 0 24px !important;\n      display: block;\n}\n.my-table thead tr:first-of-type {\n    height: 60px !important;\n}\n.index-w {\n  width: 20px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, ".width-adj[data-v-69d10534]{width:300px;min-width:300px}table[data-v-69d10534]{width:100%;border-collapse:collapse!important;text-align:left;border:1px solid rgba(0,0,0,.12)!important}table th[data-v-69d10534]{opacity:.75!important}table td[data-v-69d10534],table th[data-v-69d10534]{padding:12px!important}table tr[data-v-69d10534]{height:48px!important}table tbody th[data-v-69d10534]{width:300px}.title[data-v-69d10534]{font-size:1.2rem;opacity:.75;font-weight:700}.sub-title[data-v-69d10534]{font-weight:700;opacity:.75;font-size:1.1rem}.sub-title span[data-v-69d10534]{color:blue}.month-year p[data-v-69d10534]{font-size:24px;color:#ffb300}.month-year span[data-v-69d10534]{color:rgba(0,0,0,.67)}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/LicenseReportDetailsModal.vue"],"names":[],"mappings":"AACA,4BACE,YAAa,AACb,eAAiB,CAClB,AACD,uBACE,WAAY,AACZ,mCAAqC,AACrC,gBAAiB,AACjB,0CAAiD,CAClD,AACD,0BACI,qBAAwB,CAC3B,AACD,oDACI,sBAAyB,CAC5B,AACD,0BACI,qBAAwB,CAC3B,AACD,gCACI,WAAa,CAChB,AACD,wBACE,iBAAkB,AAClB,YAAa,AACb,eAAiB,CAClB,AACD,4BACE,gBAAiB,AACjB,YAAa,AACb,gBAAkB,CACnB,AACD,iCACI,UAAY,CACf,AACD,+BACE,eAAgB,AAChB,aAAe,CAChB,AACD,kCACE,qBAA2B,CAC5B","file":"LicenseReportDetailsModal.vue","sourcesContent":["\n.width-adj[data-v-69d10534] {\n  width: 300px;\n  min-width: 300px;\n}\ntable[data-v-69d10534] {\n  width: 100%;\n  border-collapse: collapse !important;\n  text-align: left;\n  border: 1px solid rgba(0, 0, 0, 0.12) !important;\n}\ntable th[data-v-69d10534] {\n    opacity: .75 !important;\n}\ntable th[data-v-69d10534], table td[data-v-69d10534] {\n    padding: 12px !important;\n}\ntable tr[data-v-69d10534] {\n    height: 48px !important;\n}\ntable tbody th[data-v-69d10534] {\n    width: 300px;\n}\n.title[data-v-69d10534] {\n  font-size: 1.2rem;\n  opacity: .75;\n  font-weight: 700;\n}\n.sub-title[data-v-69d10534] {\n  font-weight: 700;\n  opacity: .75;\n  font-size: 1.1rem;\n}\n.sub-title span[data-v-69d10534] {\n    color: blue;\n}\n.month-year p[data-v-69d10534] {\n  font-size: 24px;\n  color: #FFB300;\n}\n.month-year span[data-v-69d10534] {\n  color: rgba(0, 0, 0, 0.67);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(525);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("093e3a9d", content, true, {});

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(526);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("4a805a6d", content, true, {});

/***/ }),

/***/ 585:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 py-3"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.licenseUsage) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "month-year layout row wrap",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.licenseUsage.month) ? _c('p', {
    staticClass: "pa-3 ma-0"
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.labels.month) + ":\n          "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.months[parseInt(_vm.licenseUsage.month, 10) - 1].text))])]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.year) ? _c('p', {
    staticClass: "pa-3 ma-0"
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.labels.year) + ":\n          "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.licenseUsage.year))])]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('p', {
    staticClass: "pa-3 ma-0"
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.labels.rgu) + ":\n          "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.counter))])]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "v-table__overflow pa-3"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.productionLicenses))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.testLicense))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.totalActive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.noOfActiveProdLicenses || 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.noOfActiveTestLicenses || 0))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.totalConcurrent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.concurrentUsersForProdLicense || 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.concurrentUsersForTestLicense || 0))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "v-table__overflow pa-3"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.active))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.inactive))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.registeredUsers))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.noOfActiveUsers || 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.noOfInactiveUsers || 0))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "v-table__overflow pa-3"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.active))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.inactive))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.domains))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.domainResourceDetails ? _vm.licenseUsage.domainResourceDetails.noOfActiveDomains : 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.domainResourceDetails ? _vm.licenseUsage.domainResourceDetails.noOfInactiveDomains : 0))])])])])]), _vm._v(" "), (_vm.licenseUsage.webSpaceDetails) ? _c('div', {
    staticClass: "v-table__overflow pa-3"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.webSpaceTypes))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.active))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.inactive))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.premium))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.premium ? _vm.licenseUsage.webSpaceDetails.premium.noOfActiveWebSpaces : 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.premium ? _vm.licenseUsage.webSpaceDetails.premium.noOfInactiveWebSpaces : 0))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.basic))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.basic ? _vm.licenseUsage.webSpaceDetails.basic.noOfActiveWebSpaces : 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.basic ? _vm.licenseUsage.webSpaceDetails.basic.noOfInactiveWebSpaces : 0))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.link))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.link ? _vm.licenseUsage.webSpaceDetails.link.noOfActiveWebSpaces : 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.link ? _vm.licenseUsage.webSpaceDetails.link.noOfInactiveWebSpaces : 0))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.custom))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.custom ? _vm.licenseUsage.webSpaceDetails.custom.noOfActiveWebSpaces : 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.custom ? _vm.licenseUsage.webSpaceDetails.custom.noOfInactiveWebSpaces : 0))])])])])]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.webShopResourceDetails) ? _c('div', {
    staticClass: "v-table__overflow pa-3"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.active))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.inactive))]), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('th', {
    staticClass: "customHeader"
  }, [_c('td', {
    staticClass: "topHeader"
  }, [_vm._v(_vm._s(_vm.$lang.header.webshop))]), _vm._v(" "), _c('td', {
    staticClass: "bottomHeader column text-xs-center",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$lang.license.orders))])]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('th', {
    staticClass: "bottomHeader column text-xs-center",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$lang.license.totalAmount))]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('th', {
    staticClass: "customHeader"
  }, [_c('td', {
    staticClass: "topHeader"
  }, [_vm._v(_vm._s(_vm.$lang.header.orderingApp))]), _vm._v(" "), _c('td', {
    staticClass: "bottomHeader column text-xs-center",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$lang.license.orders))])]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('th', {
    staticClass: "bottomHeader column text-xs-center",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$lang.license.totalAmount))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.webShopRes))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webShopResourceDetails.noOfActiveWebShopResources || 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webShopResourceDetails.noOfInactiveWebShopResources || 0))]), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                  " + _vm._s(_vm.licenseUsage.webShopResourceDetails.ordersData.webshop ? _vm.licenseUsage.webShopResourceDetails.ordersData.webshop.noOfOrders : '-') + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                  " + _vm._s(_vm.licenseUsage.webShopResourceDetails.ordersData.webshop ? _vm.licenseUsage.webShopResourceDetails.ordersData.webshop.ordersSum : '-') + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                  " + _vm._s(_vm.licenseUsage.webShopResourceDetails.ordersData['ordering app'] ? _vm.licenseUsage.webShopResourceDetails.ordersData['ordering app'].noOfOrders : '-') + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                  " + _vm._s(_vm.licenseUsage.webShopResourceDetails.ordersData['ordering app'] ? _vm.licenseUsage.webShopResourceDetails.ordersData['ordering app'].ordersSum : '-') + "\n                ")]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), (_vm.licenseUsage.userDetails) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "v-table__overflow pa-3"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v(_vm._s(_vm.$lang.license.category))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.module))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.users))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v(_vm._s(_vm.$lang.license.moon))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.paymentM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Payment Management'] ? _vm.licenseUsage.userDetails['Payment Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.contactM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Contact Management'] ? _vm.licenseUsage.userDetails['Contact Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.reportsM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Reports Management'] ? _vm.licenseUsage.userDetails['Reports Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.ordertM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Order Management'] ? _vm.licenseUsage.userDetails['Order Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.invoiceM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Invoice Management'] ? _vm.licenseUsage.userDetails['Invoice Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.inventoryM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Inventory Management'] ? _vm.licenseUsage.userDetails['Inventory Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.drawerHandlerM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Drawer Handler Management'] ? _vm.licenseUsage.userDetails['Drawer Handler Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.DBOptM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['DB Optimization Management'] ? _vm.licenseUsage.userDetails['DB Optimization Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.moonBackupM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Moon Backup Management'] ? _vm.licenseUsage.userDetails['Moon Backup Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v(_vm._s(_vm.$lang.license.sun))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.autoJobM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['AutoJob Management'] ? _vm.licenseUsage.userDetails['AutoJob Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.catalogM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Catalog Management'] ? _vm.licenseUsage.userDetails['Catalog Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.printerM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Printer Management'] ? _vm.licenseUsage.userDetails['Printer Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.printServerM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['PrintServer Management'] ? _vm.licenseUsage.userDetails['PrintServer Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.licenseM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['License Management'] ? _vm.licenseUsage.userDetails['License Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.tableM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Table Management'] ? _vm.licenseUsage.userDetails['Table Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.accountM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Account Management'] ? _vm.licenseUsage.userDetails['Account Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.companyM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Company Management'] ? _vm.licenseUsage.userDetails['Company Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.sunBackupM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Sun Backup Management'] ? _vm.licenseUsage.userDetails['Sun Backup Management'].noOfUsers : 0))])])])])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.licenseUsage) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-3": ""
    }
  }, [_c('h2', {
    staticClass: "title mb-3"
  }, [_vm._v(_vm._s(_vm.$lang.license.userCounts))]), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? [(_vm.licenseUsage.aggregateUserCountsPerLicenseType) ? _vm._l((_vm.aggUserCountPerLicenseType), function(data, index) {
    return (_vm.aggUserCountPerLicenseType.length > 0) ? _c('div', {
      key: index,
      class: {
        'mt-3': index === _vm.aggUserCountPerLicenseType.length - 1
      }
    }, [_c('h3', {
      staticClass: "sub-title mb-2"
    }, [_c('span', [_vm._v(_vm._s(_vm.$lang.license.type) + ":")]), _vm._v(" " + _vm._s(data.type))]), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-0 my-table",
      attrs: {
        "headers": _vm.userCOuntPerLTHeaders,
        "items": data.companies,
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "index-w"
          }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
            staticClass: "success--text width-adj"
          }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center success--text"
          }, [_vm._v(_vm._s(props.item.noOfConcurrentUsers))])]
        }
      }], null, true)
    })], 1) : _vm._e()
  }) : _c('div', [_vm._v("No data available.")])] : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "daily" || _vm.licenseUsage.type === "monthly") ? [(_vm.licenseUsage.userCountsPerLicenseType) ? _vm._l((_vm.userCountPerLicenseType), function(data, index) {
    return (_vm.userCountPerLicenseType.length > 0) ? _c('div', {
      key: index,
      class: {
        'mt-3': index === _vm.userCountPerLicenseType.length - 1
      }
    }, [_c('h3', {
      staticClass: "sub-title mb-2"
    }, [_c('span', [_vm._v(_vm._s(_vm.$lang.license.type) + ":")]), _vm._v(" " + _vm._s(data.type))]), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-0 my-table",
      attrs: {
        "headers": _vm.userCOuntPerLTHeaders,
        "items": data.companies,
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "index-w"
          }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
            staticClass: "success--text width-adj"
          }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center success--text"
          }, [_vm._v(_vm._s(props.item.noOfConcurrentUsers))])]
        }
      }], null, true)
    })], 1) : _vm._e()
  }) : _c('div', [_vm._v("No data available.")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.licenseUsage) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-3": ""
    }
  }, [_c('h2', {
    staticClass: "title mb-2"
  }, [_vm._v(_vm._s(_vm.$lang.license.domainsByWSType))]), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? [(_vm.licenseUsage.aggregateDomainNamesPerWebSpaceType) ? _vm._l((_vm.aggDomainsPerWebSpace), function(data, index) {
    return (_vm.aggDomainsPerWebSpace.length > 0) ? _c('div', {
      key: index,
      class: {
        'mb-3': index !== _vm.aggDomainsPerWebSpace.length - 1
      }
    }, [_c('h3', {
      staticClass: "sub-title mb-2"
    }, [_c('span', [_vm._v(_vm._s(_vm.$lang.license.type) + ":")]), _vm._v(" " + _vm._s(data.type))]), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-0 my-table",
      attrs: {
        "headers": _vm.domainsPerWSHeaders,
        "items": data.companies,
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "index-w"
          }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
            staticClass: "width-adj"
          }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', {
            staticClass: "success--text"
          }, [_vm._v(_vm._s(props.item.domainNames.join(', ')))])]
        }
      }], null, true)
    })], 1) : _vm._e()
  }) : _c('div', [_vm._v("No data available.")])] : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "daily" || _vm.licenseUsage.type === "monthly") ? [(_vm.licenseUsage.domainNamesPerWebSpaceType) ? _vm._l((_vm.getSortedKeys(_vm.licenseUsage.domainNamesPerWebSpaceType)), function(type, index) {
    return (_vm.getSortedKeys(_vm.licenseUsage.domainNamesPerWebSpaceType).length > 0) ? _c('div', {
      key: index,
      class: {
        'mb-3': index !== _vm.getSortedKeys(_vm.licenseUsage.domainNamesPerWebSpaceType).length - 1
      }
    }, [_c('h3', {
      staticClass: "sub-title mb-3"
    }, [_c('span', [_vm._v(_vm._s(_vm.$lang.license.type) + ":")]), _vm._v(" " + _vm._s(type))]), _vm._v(" "), _c('div', {
      staticClass: "v-table__overflow"
    }, [_c('table', {
      staticClass: "v-datatable v-table theme--light"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "index-w"
    }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.domainNames))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "success--text"
    }, [_vm._v(_vm._s(_vm.licenseUsage.domainNamesPerWebSpaceType[type].join(', ')))])])])])])]) : _vm._e()
  }) : _c('div', [_vm._v("No data available.")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.licenseUsage) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-3": ""
    }
  }, [_c('h2', {
    staticClass: "title mb-3"
  }, [_vm._v(_vm._s(_vm.$lang.license.webShopResourceByType))]), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? [(_vm.licenseUsage.aggregatedWebShopResourcesPerSubscriptionModel) ? _vm._l((_vm.webshopResPerSub), function(data, index) {
    return (_vm.webshopResPerSub.length > 0) ? _c('div', {
      key: index,
      class: {
        'mb-3': index !== _vm.webshopResPerSub.length - 1
      }
    }, [_c('h3', {
      staticClass: "sub-title mb-3"
    }, [_c('span', [_vm._v(_vm._s(_vm.$lang.license.type) + ":")]), _vm._v(" " + _vm._s(data.type))]), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-0 my-table",
      attrs: {
        "headers": _vm.webshopResPerSubHeaders,
        "items": data.companies,
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "headers",
        fn: function(props) {
          return [_c('tr', [_c('th', {
            staticClass: "bottomHeader column text-xs-left"
          }, [_vm._v("#")]), _vm._v(" "), _c('th', {
            staticClass: "bottomHeader column text-xs-left"
          }, [_vm._v(_vm._s(_vm.$lang.license.companyName))]), _vm._v(" "), _c('th', {
            staticClass: "bottomHeader column text-xs-left"
          }, [_vm._v(_vm._s(_vm.$lang.license.webShopResourceName))]), _vm._v(" "), _c('th', {
            staticClass: "bottomHeader column text-xs-left"
          }, [_vm._v(_vm._s(_vm.$lang.license.webShopResourceId))]), _vm._v(" "), _c('th', {
            staticClass: "customHeader"
          }, [_c('td', {
            staticClass: "topHeader"
          }, [_vm._v(_vm._s(_vm.$lang.header.webshop))]), _vm._v(" "), _c('td', {
            staticClass: "bottomHeader column",
            attrs: {
              "role": "columnheader",
              "scope": "col"
            }
          }, [_vm._v(_vm._s(_vm.$lang.license.orders))])]), _vm._v(" "), _c('th', {
            staticClass: "bottomHeader column",
            attrs: {
              "role": "columnheader",
              "scope": "col"
            }
          }, [_vm._v(_vm._s(_vm.$lang.license.totalAmount))]), _vm._v(" "), _c('th', {
            staticClass: "customHeader"
          }, [_c('td', {
            staticClass: "topHeader"
          }, [_vm._v(_vm._s(_vm.$lang.header.orderingApp))]), _vm._v(" "), _c('td', {
            staticClass: "bottomHeader column",
            attrs: {
              "role": "columnheader",
              "scope": "col"
            }
          }, [_vm._v(_vm._s(_vm.$lang.license.orders))])]), _vm._v(" "), _c('th', {
            staticClass: "bottomHeader column",
            attrs: {
              "role": "columnheader",
              "scope": "col"
            }
          }, [_vm._v(_vm._s(_vm.$lang.license.totalAmount))])])]
        }
      }, {
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "index-w"
          }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
            staticClass: "width-adj"
          }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', {
            staticClass: "width-adj"
          }, [_vm._v(_vm._s(props.item.webShopResourceName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.webShopResourceId))]), _vm._v(" "), _c('td', {
            staticClass: "success--text"
          }, [_vm._v(_vm._s(_vm.getOrderData(props.item.ordersData, 'webshop', 'noOfOrders')))]), _vm._v(" "), _c('td', {
            staticClass: "success--text"
          }, [_vm._v(_vm._s(_vm.getOrderData(props.item.ordersData, 'webshop', 'ordersSum')))]), _vm._v(" "), _c('td', {
            staticClass: "success--text"
          }, [_vm._v(_vm._s(_vm.getOrderData(props.item.ordersData, 'ordering app', 'noOfOrders')))]), _vm._v(" "), _c('td', {
            staticClass: "success--text"
          }, [_vm._v(_vm._s(_vm.getOrderData(props.item.ordersData, 'ordering app', 'ordersSum')))])]
        }
      }], null, true)
    })], 1) : _vm._e()
  }) : _c('div', [_vm._v("No data available.")])] : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "daily" || _vm.licenseUsage.type === "monthly") ? [(_vm.licenseUsage.webShopResourcesPerSubscriptionModel) ? _vm._l((_vm.getSortedKeys(_vm.licenseUsage.webShopResourcesPerSubscriptionModel)), function(type, index) {
    return (_vm.getSortedKeys(_vm.licenseUsage.webShopResourcesPerSubscriptionModel).length > 0) ? _c('div', {
      key: index,
      class: {
        'mb-3': index !== _vm.getSortedKeys(_vm.licenseUsage.webShopResourcesPerSubscriptionModel).length - 1
      }
    }, [_c('h3', {
      staticClass: "sub-title mb-2"
    }, [_c('span', [_vm._v(_vm._s(_vm.$lang.license.type) + ":")]), _vm._v(" " + _vm._s(type))]), _vm._v(" "), _c('div', {
      staticClass: "v-table__overflow"
    }, [_c('table', {
      staticClass: "v-datatable v-table theme--light"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "index-w"
    }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.webShopResourceName))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.webShopResourceId))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.licenseUsage.webShopResourcesPerSubscriptionModel[type]), function(resource, index2) {
      return _c('tr', {
        key: index2
      }, [_c('td', [_vm._v(_vm._s(index2 + 1))]), _vm._v(" "), _c('td', {
        staticClass: "success--text width-adj"
      }, [_vm._v(_vm._s(resource.webShopResourceName))]), _vm._v(" "), _c('td', {
        staticClass: "success--text"
      }, [_vm._v(_vm._s(resource.webShopResourceId))])])
    }), 0)])])]) : _vm._e()
  }) : _c('div', [_vm._v("No data available.")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n      " + _vm._s(_vm.$lang.actions.close) + "\n    ")], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.91b4dbc333acdfadef63.js